import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import OrderItemsMobile from './OrderItemsMobile';
import OrderDeliveryMobile from './OrderDeliveryMobile';
import { BASE_URL } from '../../../shared/constants';
import OrderInfoBlockMobile from './OrderInfoBlockMobile';

const OrderConfirmationMobile = ({ order, paymentSettings }) => {

  const [modalImage, setModalImage] = useState('');

  if (!order) {
    return null;
  }

  return (
    <div className='order-confirmation-content'>

      {/* ===== HEADER ===== */}
      <div className='py-2 text-center'>
        <h5 className='font-weight-bold mb-1'>Дякуємо за замовлення!</h5>
      </div>


      <OrderInfoBlockMobile
        doNotCall={order.doNotCall}
        paymentType={order.paymentType}
        paymentStatus={order.paymentStatus}
        discountedPrice={order.discountedPrice}
        orderId={order.orderId}
        paymentSettings={paymentSettings}
        items={order.items}
      />

      {/* ===== ITEMS ===== */}
      <OrderItemsMobile
            order={order}
        items={order.items}
        totalPrice={order.totalPrice}
        discountedPrice={order.discountedPrice}
        setModalImage={setModalImage}
      />

      {/* ===== DELIVERY ===== */}
      <OrderDeliveryMobile delivery={order.delivery} />

      {/* ===== USER COMMENT ===== */}
      {order.userComment && (
        <div className='card mb-3'>
          <h5 className='card-header font-weight-bold p-2'>
            💬 Ваш коментар до замовлення
          </h5>
          <div className='card-body'>
            <div style={{ whiteSpace: 'pre-line' }}>{order.userComment}</div>
          </div>
        </div>
      )}

      {/* ===== CONTACT INFO ===== */}
      <div className='text-center text-muted mb-3 px-3'>
        <p className='mb-0'>
          З будь-яких питань -{' '}
          <a
            href='https://t.me/waaaghShopAdmin'
            target='_blank'
            rel='noopener noreferrer'
            className='font-weight-bold'
          >
            звертайтеся до нас у Telegram
          </a>{' '}
          або телефонуйте за номером, вказаним у шапці сайту
        </p>
      </div>

      {/* ===== ACTIONS ===== */}
      <div className='text-center pb-3'>
        <Link to='/user/personal-cabinet' className='btn btn-dark mr-2'>
          Мої замовлення
        </Link>
        <Link to='/' className='btn btn-success'>
          На головну
        </Link>
      </div>

      <div
        className="modal fade"
        id="imageModalMobile"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
          <div className="modal-content bg-transparent border-0">
            <div className="modal-body p-0 text-center">
              <img
                src={`${BASE_URL}/api/v1/product/image/${modalImage}`}
                alt="Product"
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default OrderConfirmationMobile;
